const vacationTypes = [
  { label: 'Adicionales', value: 'additional_days' },
  { label: 'Legales (+Proporcionales)', value: 'legal' },
  { label: 'Progresivas', value: 'progressive' }
];

export default vacationTypes;
